import React, { useContext, useState } from 'react'
import { ButtonForCreateAFunction, InputDiv, SelectData, TabDiv, TabsDiv, TabText } from '../style'
import axios from 'axios'
import ModalContext from '../../../contexts/ModalContext'
import { companyComponentsProps } from '../DisponibilityComponent'
import close from '../../../assets/close-icon.svg'

export interface functionsType {
  id:number
  name:string
}

const SelectFunctionsComponent:React.FC<companyComponentsProps> = (props) => {
  const { company, setCompany } = props
  const { setModalSection, setModalActive, setLastSection } = useContext(ModalContext)
  const [ allFunctions, setAllFunctions ] = useState<functionsType[]>([])
  
  const handleGetAllFunctions = () => {
    axios.get(`${process.env.REACT_APP_PRODUCTION_FLOW_BASE_URL}/functions`)
      .then(response => {
        if(response.data)
          setAllFunctions(response.data)
        return
      })
      .catch(error => {
        console.error(error)
      })
  }
  
  return(
    <InputDiv>
      <SelectData value='' onFocus={handleGetAllFunctions} onChange={(e) => setCompany((prev:any) => {
        const functionId = Number(e.target.value)
        const isRepeated = prev.functions.filter((f:any) => f.id == functionId)
        if(isRepeated.length > 0) return prev
        const functionObject = allFunctions.filter(f => f.id == functionId)
        return {
          ...prev,
          functions:[...prev.functions, functionObject[0]]
        }
      })}>
        <option value=''>Selecione</option>
        {allFunctions.map((item, index) => 
          <option value={item.id} key={index}>{item.name}</option>
        )}
      </SelectData>
      <TabsDiv>
        {company.functions.map((companyObj, companyIndex) => (
          <TabDiv key={companyIndex}>
            <TabText>{companyObj.name}</TabText>
            <img
              src={close}
              alt="close icon"
              onClick={() => 
                setCompany((prev:any) => ({
                  ...prev,
                  functions: prev.functions.filter((_:string, index:number) => index !== companyIndex)
                }))
              }
            />
          </TabDiv>
        ))}
      </TabsDiv>
      <ButtonForCreateAFunction
        onClick={() => {
          setModalActive(true)
          setModalSection('createNewFunction')
          setLastSection('addCompany')
        }}
      >
        + Criar função
      </ButtonForCreateAFunction>
    </InputDiv>
  )
  
}

export default SelectFunctionsComponent